import { z } from "zod/v4"
import { UserId, UserIdSchema } from "../id"
import { DocumentSnapshotLike } from "../firestore"
import { CreatedAt, UpdatedAt } from "./system"
import { UserDenormalizedWithoutLook, Users } from "./user"

export const FollowDocumentBody = z.object({
  user_id: UserIdSchema, // for collection group query
  followee: UserDenormalizedWithoutLook,
  follower: UserDenormalizedWithoutLook.optional().describe("フォロワー本人の非正規化ユーザー情報。フォロワー一覧での名前検索に利用する。バックフィル完了までは undefined のドキュメントが存在しうる。"),
  is_followed_back: z.boolean().describe("フォロワーが自分もフォローしているかどうか（相互フォロー）"),
  created_at: CreatedAt,
  updated_at: UpdatedAt,
})

export type FollowDocumentBody = z.infer<typeof FollowDocumentBody>

export const FollowDocument = z.intersection(
  FollowDocumentBody,
  z.object({
    id: UserIdSchema,
  })
)

export type FollowDocument = z.infer<typeof FollowDocument>

export class Follows {

  // https://trello.com/c/Q1dtwBVC
  public static readonly LIMIT_OWN = 1999

}

export class FollowDocuments {

  static toDocumentData(follow: FollowDocument): object {
    return {
      ...follow,
      // id は document path に入るので入れない
      id: undefined,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): FollowDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: UserId(doc.id),
      followee: data["followee"] ? Users.parseDenormalizedWithoutLook(data["followee"]) : data["followee"],
      follower: data["follower"] ? Users.parseDenormalizedWithoutLook(data["follower"]) : undefined,
      user_id: data["user_id"],
      is_followed_back: data["is_followed_back"] ?? false,
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }

}
